// extracted by mini-css-extract-plugin
export default {"modal":"EditClassesModal_modal__jwaL1","pageContentWrapper":"EditClassesModal_pageContentWrapper__t6Jyc"};